import { useMutation, useQuery } from "@tanstack/react-query";

import { Base } from "../services/_base";

interface BaseInterface<T> {
  key: string;
  Service: Base<T>;
}
export const useBaseRequests = <T extends any>({ key, Service }: BaseInterface<T>) => {
  return {
    getAll(filters: any[], params: any) {
      return useQuery([`get.all.${key}`, ...filters], () =>
        Service.getAll({
          ...params,
        })
      );
    },
    count(filters: any[], params: any) {
      return useQuery([`count.${key}`, ...filters], () =>
        Service.count({
          ...params,
        })
      );
    },
    // getById() {
    //   return useQuery([`get.by.id.${key}`], (dataId: number) => Service.getById(dataId));
    // },
    create() {
      return useMutation([`create.${key}`], (data: T) => Service.create(data));
    },
    update() {
      return useMutation([`update.${key}`], ({ id, data }: { id: number; data: T }) =>
        Service.update(id, data)
      );
    },
  };
};
